import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class="socials" >
      <b class="powered_by">
        <span class="mr-1">Powered by</span>
        <a href="https://lantern.tech" target="_blank">
        <img src="../../../../assets/images/lantern-logo.png">
        </a>
      </b>
    </div>
  `,
})
export class FooterComponent {
}
